export { default } from './ModuleConfigPage'
